export default {
  rewards: {
    title: "Recompensas",
    claim: "Reclamar",
    weeklyCashback: "Cashback Semanal",
    weeklyCashbackDesc: "Recupera una parte de tus pérdidas semanales cada semana.",
    dailySpin: "Giro Diario",
    dailySpinDesc: "Gira la ruleta a diario para tener la oportunidad de ganar grandes premios.",
    invitationBonus: "Bono de Invitación",
    invitationBonusDesc: "Invita a tus amigos y gana recompensas por cada uno que se una.",
    rebate: "Reembolso",
    rebateDesc: "Gana reembolsos en cada apuesta que hagas, ganes o pierdas.",
    bannerTitle: "RECOMPENSAS",
    bannerSubtitle: "¡Completa tareas y gana recompensas increíbles!",
    sectionTitle: "Tus Recompensas Increíbles",
    goNow: "Ir Ahora",
    historyReceived: "Total recibido",
    todayReceived: "Recibido hoy",
    cashbackDialog: {
      title: "Cashback de Apuesta",
      loading: "Cargando...",
      empty: "Sin reglas de cashback",
      level: "Nivel",
      amountRange: "Rango de Importe",
      rewardRate: "Tasa de Recompensa",
      rewardCap: "Límite de Recompensa",
    },
    cards: {
      checkin: {
        title: "Check-in Diario",
        subtitle: "Inicia sesión para hacer check-in a diario",
        description: "Jugadores, no olviden hacer check-in cada día~",
      },
      cashback: {
        title: "Cashback",
        subtitle: "Recompensas de reembolso de la plataforma",
      },
      rescue: {
        title: "Bono de Rescate",
        subtitle: "Juega 3 partidas con dinero real",
        description: "Fondos de rescate para jugadores en bancarrota",
      },
      task: {
        title: "Tareas",
        subtitle: "Completa tareas de la plataforma",
        description: "Tareas de la plataforma",
      },
      balance: {
        title: "Bóveda",
        subtitle: "Gana intereses diarios",
        description: "Bóveda de la plataforma",
      },
      loan: {
        title: "Bono de Préstamo",
        subtitle: "Préstamos fáciles",
        description: "Préstamo de la plataforma",
      },
    },
    checkIn: {
      dailySignIn: "CHECK-IN DIARIO",
      totalRewards: "RECOMPENSAS TOTALES",
      headlineDaysBefore: "Haz check-in durante",
      headlineDaysAfter: "días,",
      headlineTailCumulative: "no importa si te saltas un día.",
      headlineTailDate: "saltarse un día pierde la recompensa de ese día.",
      headlineCumulative: "Haz check-in {days} días para ganar en grande, no importa si te saltas un día.",
      headlineDate: "Haz check-in {days} días, saltarse un día pierde la recompensa de ese día.",
      headlineEmpty: "Haz check-in para ganar recompensas",
      title: "Check-in",
      modeCumulative: "Check-in Acumulativo",
      modeDate: "Check-in por Fecha",
      rewards: "Recompensas",
      signedIn: "Check-in hecho",
      day: "Día {n}",
      loading: "Cargando...",
      empty: "Sin actividad de check-in activa.",
      btnCheckIn: "Check-in",
      btnSigned: "Ya hecho",
      btnLocked: "Bloqueado",
      claimSuccess: "Check-in exitoso, recompensa de {amount} {currency} acreditada",
      claimFailed: "Check-in fallido",
      alreadySigned: "Ya has hecho check-in hoy",
      notLogin: "Por favor, inicia sesión primero",
    },
  },
};
